import React, { useEffect, useState } from 'react';
import { Box, Typography, Button } from '@material-ui/core';
import CustomModal from '../eir-porting/CustomModal/CustomModal';
import SimCostDisplay from './SimCostDisplay';
import SimEircode from './SimEircode';
import CustomUpdatedPopUpModal from '../eir-porting/CustomModal/CustomUpdatedPopUpModal';
import useStyles from './style';
import { Controller, useForm, ErrorMessage } from 'react-hook-form';
import success from '../images/Large-icon-Success.png';
import { Scrollbars } from 'react-custom-scrollbars';
import { getSimCardCharges } from './simCardCharges.util';
import { useApolloClient } from '@apollo/client';
import { submitSimReplacement } from './submitSimRequest.util';
import InactiveSim from '../eir-sim-replacement/InactiveSim';
import { ReFormatCounty } from '../addressFormat';
import EirButton from '../../theme/EirButton';

const SimReplacementContainer = props => {
    const classes = useStyles();
    const [openSim, setOpenSimModal] = useState(false);
    const [openCustomPopup, setOpenCustomPopup] = useState(false);
    const [submitData, setSubmitData] = useState('');
    const [simCost, setSimCost] = useState(0);
    const [openInactiveModal, setOpenInactiveModal] = useState(false);
    const [isEnabled, setIsEnabled] = useState(true);
    const [isTicked, setIsTicked] = useState(false);
    const [isError, setIsError] = useState(false);

    const [cta1, setCTA1] = useState({ text: '', action: () => {}, disable: false });
    const [cta2, setCTA2] = useState({ text: '', action: () => {}, disable: false });

    const { register, control, errors, handleSubmit, setValue, setError, clearError } = useForm({
        reValidateMode: 'onChange',
        mode: 'onChange',
    });

    const [submitFormData, setSubmitFormData] = useState({
        address: {
            addressLine1: '',
            addressLine2: '',
            addressLine3: '',
            code: '',
            town: '',
            county: '',
        },
        email: '',
        phoneNum: '',
        firstName: '',
        lastName: '',
    });

    const submitFormAction = addressValues => {
        setSubmitFormData({
            ...submitFormData,
            address: addressValues.address,
        });
    };

    // submit action
    const handleSubmitSimRequest = async () => {
        try {
            console.log('form values', submitFormData);
            const data = await submitSimReplacement({
                graphql,
                request: {
                    address: {
                        addressLine1: submitFormData.address.addressLine1,
                        addressLine2: submitFormData.address.addressLine2,
                        code: submitFormData.address.code,
                        county: ReFormatCounty(submitFormData.address.county),
                        town: submitFormData.address.town,
                    },

                    barServices: isTicked,
                    email: submitFormData.email,
                    firstName: submitFormData.firstName,
                    lastName: submitFormData.lastName,
                    phoneNumber: submitFormData.phoneNum,
                    serviceId: props.serviceId,
                },
                token: sessionStorage.getItem('access_token'),
            });
            console.log('Submit order sim:', data);
        } catch (error) {
            setOpenSimModal(true);
            setOpenCustomPopup(false);
            setOpenInactiveModal(false);
            setIsError(true);
            console.log('Sim submit error', error);
        }
    };

    //cost charges for sim
    const graphql = useApolloClient();

    const getSimChargesResponse = async () => {
        try {
            const data = await getSimCardCharges({
                graphql,
                token: sessionStorage.getItem('access_token'),
                serviceId: props.serviceId,
            });
            setSimCost(data.getSimSwapCharges.charges[0].defaultPriceVatIncluded);
        } catch (error) {
            console.log('Sim charges error', error);
        }
    };

    // openSim modal
    const handleOpen = () => {
        setOpenCustomPopup(false);
        setOpenSimModal(true);
        // setCTA1({ text: 'Submit', action: (props.flag ? handleReorderSubmit : handleSimCtaClick), disable: false })
        // setCTA2({ text: 'Cancel', action: () => setOpenSimModal(false), disable: false })
    };

    const handleSaveData = () => {
        handleSubmitSimRequest();
        setOpenSimModal(false);
        setOpenCustomPopup(true);
    };

    //re-order submit
    const handleReorderSubmit = () => {
        setOpenSimModal(false);
        setOpenInactiveModal(!openInactiveModal);
    };

    // handle back arrow action
    const backArrowAction = () => {
        setOpenSimModal(!openSim);
        setIsError(false);
    };

    //handle popup button
    const handleAltCta = () => {
        props.getSimEligibilityResponse();
        setOpenCustomPopup(false);
        props.setOpen(false);
    };

    const handleClose = () => {
        console.log('cross icon clicked');
    };

    const handleTogglePopup = () => {
        setOpenCustomPopup(!openCustomPopup);
    };

    useEffect(() => {
        props.open && handleOpen();
    }, [props.open]);

    useEffect(() => {
        getSimChargesResponse();
    }, []);

    useEffect(() => {
        props.flag
            ? setSubmitFormData({
                  address: {
                      addressLine1: props.reorderForm?.address?.addressLine1,
                      addressLine2: props.reorderForm?.address?.addressLine2,
                      addressLine3: props.reorderForm?.address?.addressLine3,
                      code: props.reorderForm?.address?.code,
                      town: props.reorderForm?.address?.town,
                      county: props.reorderForm?.address?.county,
                  },
                  email: props.ContactDetails?.emails[0].email,
                  phoneNum: props.ContactDetails?.phoneNumbers[0]?.phoneNumber,
                  firstName: props.ContactDetails?.firstName,
                  lastName: props.ContactDetails?.lastName,
              })
            : setSubmitFormData({
                  address: {
                      addressLine1: props.ContactDetails?.addresses[0]?.addressLine1,
                      addressLine2: props.ContactDetails?.addresses[0]?.addressLine2,
                      addressLine3: props.ContactDetails?.addresses[0]?.addressLine3,
                      code: props.ContactDetails?.addresses[0]?.code,
                      town: props.ContactDetails?.addresses[0]?.town,
                      county: props.ContactDetails?.addresses[0]?.county,
                  },
                  email: props.ContactDetails?.emails[0].email,
                  phoneNum: props.ContactDetails?.phoneNumbers[0]?.phoneNumber,
                  firstName: props.ContactDetails?.firstName,
                  lastName: props.ContactDetails?.lastName,
              });
    }, [props]);

    return (
        <Box id='sim-replacement'>
            <Typography component='span' onClick={handleOpen} className={classes.simLink}>
                {props.linkName}
            </Typography>

            <CustomModal
                open={openSim}
                toggle={backArrowAction}
                cta1={cta1}
                cta2={cta2}
                header={{ text: 'Replace my SIM', arrowAction: backArrowAction, center: false }}
                description='Replace my SIM description'
                ariaLabel='Replace my SIM opens popup'
            >
                <Scrollbars className={classes.scrollbar}>
                    <SimCostDisplay cost={props.flag ? props.reorderCost : props.simCost} />
                    <SimEircode
                        ContactDetails={props.ContactDetails}
                        register={register}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        submitFormAction={submitFormAction}
                        submitFormData={submitFormData}
                        setSubmitFormData={setSubmitFormData}
                        setIsEnabled={setIsEnabled}
                        setIsTicked={setIsTicked}
                        reorderForm={props.reorderForm}
                        flag={props.flag}
                    />
                </Scrollbars>
                <Box className={classes.buttonBox}>
                    {isError ? (
                        <Box className={classes.err}>
                            Something went wrong, Please try again later!
                        </Box>
                    ) : (
                        ''
                    )}
                    <EirButton
                        variants='primaryButtonMedium'
                        style={{ padding: '0.5rem 2.5rem' }}
                        disabled={!isEnabled}
                        onClick={props.flag ? handleReorderSubmit : handleSaveData}
                        // className={`${classes.simCta}  ${
                        //     isEnabled ? classes.simCta1 : classes.simCta1Disable
                        // } `}
                    >
                        Submit
                    </EirButton>
                    <Button
                        onClick={backArrowAction}
                        className={`${classes.simCta} ${classes.simCta2} `}
                    >
                        Cancel
                    </Button>
                </Box>
            </CustomModal>

            <Box id='my-eir-pop-up'>
                <CustomUpdatedPopUpModal
                    open={openCustomPopup}
                    toggle={handleTogglePopup}
                    cta1={{ text: 'Close', action: handleAltCta, disable: false }}
                    cta2={{ text: '', action: () => {} }}
                >
                    <Box className={classes.successPopup}>
                        <Box className={classes.successImg}>
                            <Typography component='img' src={success} alt='success' />
                        </Box>

                        <Typography className={classes.imgTextAdditional}>
                            Your replacement SIM has been ordered
                        </Typography>
                    </Box>
                </CustomUpdatedPopUpModal>
            </Box>
            {openInactiveModal && (
                <InactiveSim
                    open={openInactiveModal}
                    setOpen={setOpenInactiveModal}
                    setOpenSimModal={setOpenSimModal}
                    setOpenCustomPopup={setOpenCustomPopup}
                    handleSubmitSimRequest={handleSubmitSimRequest}
                />
            )}
        </Box>
    );
};

export default SimReplacementContainer;
